const pickFirst = (...values) => {
  for (const value of values) {
    if (value === null || value === undefined) continue;
    const text = String(value).trim();
    if (text) return text;
  }

  return "";
};

const normalizeRoleNames = (user) => {
  const fromArray = Array.isArray(user?.roleNames)
    ? user.roleNames
    : Array.isArray(user?.RoleNames)
      ? user.RoleNames
      : [];

  if (fromArray.length) {
    return fromArray.map((item) => String(item || "").trim()).filter(Boolean);
  }

  const single = pickFirst(user?.roleName, user?.RoleName, user?.role, user?.Role);
  return single ? [single] : [];
};

export const normalizeAuthUser = (user) => {
  const source = user || {};
  const roleNames = normalizeRoleNames(source);

  return {
    ...source,
    userId: pickFirst(source.userId, source.UserId, source.id, source.Id),
    fullName: pickFirst(source.fullName, source.FullName, source.name, source.Name, source.userName, source.UserName),
    userName: pickFirst(source.userName, source.UserName, source.username, source.UserName),
    email: pickFirst(source.email, source.Email, source.workEmail, source.WorkEmail),
    workEmail: pickFirst(source.workEmail, source.WorkEmail, source.email, source.Email),
    personalEmail: pickFirst(source.personalEmail, source.PersonalEmail),
    mobile: pickFirst(source.mobile, source.Mobile, source.phone, source.PhoneNumber),
    employeeCode: pickFirst(source.employeeCode, source.EmployeeCode, source.code, source.Code),
    employeeNumber: pickFirst(source.employeeNumber, source.EmployeeNumber),
    designationName: pickFirst(source.designationName, source.DesignationName, source.designation, source.Designation),
    departmentName: pickFirst(source.departmentName, source.DepartmentName, source.department, source.Department),
    photoUrlWithPath: pickFirst(source.photoUrlWithPath, source.PhotoUrlWithPath),
    customerCode: pickFirst(source.customerCode, source.CustomerCode),
    organizationName: pickFirst(source.organizationName, source.OrganizationName),
    roleName: pickFirst(source.roleName, source.RoleName, roleNames[0]),
    roleNames,
    RoleNames: roleNames,
  };
};

export const mergeAuthUsers = (previousUser, nextUser) => {
  const previous = normalizeAuthUser(previousUser);
  const next = normalizeAuthUser(nextUser);

  return {
    ...previous,
    ...next,
    userId: next.userId || previous.userId,
    fullName: next.fullName || previous.fullName,
    userName: next.userName || previous.userName,
    email: next.email || previous.email,
    workEmail: next.workEmail || previous.workEmail,
    personalEmail: next.personalEmail || previous.personalEmail,
    mobile: next.mobile || previous.mobile,
    employeeCode: next.employeeCode || previous.employeeCode,
    employeeNumber: next.employeeNumber || previous.employeeNumber,
    designationName: next.designationName || previous.designationName,
    departmentName: next.departmentName || previous.departmentName,
    photoUrlWithPath: next.photoUrlWithPath || previous.photoUrlWithPath,
    customerCode: next.customerCode || previous.customerCode,
    organizationName: next.organizationName || previous.organizationName,
    roleName: next.roleName || previous.roleName,
    roleNames: next.roleNames?.length ? next.roleNames : previous.roleNames || [],
    RoleNames: next.roleNames?.length ? next.roleNames : previous.RoleNames || [],
  };
};

export const getStoredAuthUser = () => {
  const raw = window.localStorage.getItem("user");
  if (!raw) return null;

  try {
    return normalizeAuthUser(JSON.parse(raw));
  } catch {
    return null;
  }
};

export const storeAuthSession = (responseData) => {
  const data = responseData || {};
  const existingUser = getStoredAuthUser();
  const mergedUser = mergeAuthUsers(existingUser, data.user || data.User || {});

  if (data.accessToken || data.AccessToken) {
    window.localStorage.setItem("authtoken", data.accessToken || data.AccessToken);
  }
  if (data.refreshToken || data.RefreshToken) {
    window.localStorage.setItem("refreshToken", data.refreshToken || data.RefreshToken);
  }
  if (data.accessTokenExpiry || data.AccessTokenExpiry) {
    window.localStorage.setItem("tokenExpiry", data.accessTokenExpiry || data.AccessTokenExpiry);
  }

  window.localStorage.setItem("user", JSON.stringify(mergedUser));
  return mergedUser;
};
